import React from "react";
import { Redirect } from "react-router-dom";

export default function RedirectWhen({
  when: conditionIsTrue,
  to,
  children
}) {
  return conditionIsTrue ? <Redirect to={to} /> : children;
}
